import { connect } from 'react-redux';
import { getFacets, getSortMetadata, getSort } from '../../../modules/Filters';
import { getBase } from '../../../modules/Settings';
import { SortJobsSelect } from './SortJobs';
import { buildNewQueryString } from '../../../app/helpers';

const mapStateToProps = state => {
  const { distance: { postcode, point } } = getFacets(state);
  const { items } = getSortMetadata(state);
  return {
    items,
    sort: getSort(state),
    includeDistanceSort: !!(postcode || point),
    base: getBase(state)
  };
};

const mapCallbacksToProps = () => ({
  onChanged: (evt, push, { pathname, qs }) => {
    const target = evt.target;
    const selected = target.options[target.selectedIndex].value;
    push({
      pathname,
      search: buildNewQueryString('sort', selected, qs)
    });
  }
});

export const SortJobs = connect(mapStateToProps, mapCallbacksToProps)(SortJobsSelect);
